import React from 'react';

const TaskStatistics = ({ 
    stats, 
    managerStats, 
    isManager, 
    activeTab, 
    activeStatCard, 
    onStatCardClick 
}) => {
    // Determine which stats to display based on tab and role
    const getCurrentStats = () => {
        if (isManager && activeTab === 'assigned-to-me' && managerStats) {
            return {
                total: managerStats.total,
                pending: managerStats.pending,
                approved: managerStats.approved,
                rejected: managerStats.rejected
            };
        }
        
        if (!stats) return null;
        if (activeTab === 'assigned-to-me') return stats.assignedToMe;
        if (activeTab === 'assigned-by-me') return stats.assignedByMe;
        return stats.allTasks;
    };

    const currentStats = getCurrentStats();

    if (!currentStats) return null;

    return (
        <div className="dashboard-stats">
            {/* Manager Approval View */}
            {isManager && activeTab === 'assigned-to-me' ? (
                <>
                    <div 
                        className={`stat-card stat-total ${activeStatCard === 'total' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('total', '')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.total}</h3>
                        <p>Total Requests</p>
                    </div>
                    <div 
                        className={`stat-card stat-pending ${activeStatCard === 'pending' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('pending', '')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.pending}</h3>
                        <p>Pending Approval</p>
                    </div>
                    <div 
                        className={`stat-card stat-approved ${activeStatCard === 'approved' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('approved', '')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.approved}</h3>
                        <p>Approved</p>
                    </div>
                    <div 
                        className={`stat-card stat-rejected ${activeStatCard === 'rejected' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('rejected', '')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.rejected}</h3>
                        <p>Rejected</p>
                    </div>
                </>
            ) : (
                /* Regular Task View */
                <>
                    <div 
                        className={`stat-card stat-total ${activeStatCard === 'total' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('total', '')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.total}</h3>
                        <p>Total</p>
                    </div>
                    <div 
                        className={`stat-card stat-todo ${activeStatCard === 'todo' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('todo', 'todo')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.todo}</h3>
                        <p>To Do</p>
                    </div>
                    <div 
                        className={`stat-card stat-progress ${activeStatCard === 'in-progress' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('in-progress', 'in-progress')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.inProgress}</h3>
                        <p>In Progress</p>
                    </div>
                    <div 
                        className={`stat-card stat-review ${activeStatCard === 'review' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('review', 'review')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.review}</h3>
                        <p>Review</p>
                    </div>
                    <div 
                        className={`stat-card stat-completed ${activeStatCard === 'completed' ? 'active' : ''}`}
                        onClick={() => onStatCardClick('completed', 'completed')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>{currentStats.completed}</h3>
                        <p>Completed</p>
                    </div>
                    {currentStats.overdue > 0 && (
                        <div 
                            className={`stat-card stat-overdue ${activeStatCard === 'overdue' ? 'active' : ''}`}
                            onClick={() => onStatCardClick('overdue', '')}
                            style={{ cursor: 'pointer' }}
                        >
                            <h3>
                                <span className="overdue-blink-indicator"></span>
                                {currentStats.overdue}
                            </h3>
                            <p>Overdue</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default TaskStatistics;
